import { hasValidModule } from './modules';

export const isSessionValid = (session) => session.is_live && hasValidModule(session);
export const findValidSession = (event) => event.sessions.find(isSessionValid);
export const hasValidSession = (event) => event.sessions.some(isSessionValid);
